/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.activities.controllers', [])

.controller('SherpaActivitiesController', ['$scope', function($scope) {

    $scope.sherpaActivities = {

    };

}]);